<div class="row">
  <app-content-tab-list activeTab="1" type="cms" category="CMS"></app-content-tab-list>

  <div class="container-fluid">
    <div class="row section1 mt-4">
      <div class="col-12 col-md-7">
        <div class="home-details">
          <h5 class="home-title">Icons</h5>
          <p class="home-subtitle">Add new icons for bhakts & Vishwagurus</p>
        </div>
      </div>
    </div>
    <div class="section1">
      <div class="applicants-details details1">
        <form class="admin-form" enctype="multipart/form-data">
          <div class="col-12 job-form">
            <form class="admin-form" (ngSubmit)="updateIcons()">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="user-form">
                    <div class="form-group d-flex flex-column">
                      <label>Choose Bhakts Icon*</label>
                      @if (!iconPayload.icons.bhakt) {
                        <img class="position-relative " style="object-fit: cover"
                          width="200"
                          height="200"
                          src="assets/images/placeholder.png" alt="">
                        }
                        @if (iconPayload.icons.bhakt) {
                          <img class="position-relative " style="object-fit: cover"
                            width="200"
                            height="200"
                            [src]="iconPayload.icons.bhakt" alt="">
                        }
                        @if (!uploadingBhakts) {
                          <i (click)="handleClickUpload('icon-bhakt')"
                          class="las font-size-16 la-pencil-alt img-icon icon"></i>
                        }
                        @if (uploadingBhakts) {
                          <div class="img-icon-loader icon">
                            <img src="assets/images/loading.gif" width="40" alt="">
                          </div>
                        }
                      </div>
                      <input id="icon-bhakt" name="file-upload-field" type="file"
                        accept=".png, .jpg, .jpeg, .webp"
                        class="form-control d-none"
                        (change)="fileChangeEvent($event, imageCropperModal, 'BHAKT')" required>
                    </div>

                  </div>
                  <div class="col-auto ">
                    <div class="user-form">
                      <div class="form-group d-flex flex-column">
                        <label>Choose Vishwagurus Icon*</label>
                        @if (!iconPayload.icons.vishvaguru) {
                          <img class="position-relative " style="object-fit: cover"
                            width="200"
                            height="200"
                            src="assets/images/placeholder.png" alt="">
                          }
                          @if (iconPayload.icons.vishvaguru) {
                            <img class="position-relative " style="object-fit: cover"
                              width="200"
                              height="200"
                              [src]="iconPayload.icons.vishvaguru" alt="">
                          }
                          @if (!uploadingVishwaguru) {
                            <i (click)="handleClickUpload('icon-vishwagurus')"
                            class="las font-size-16 la-pencil-alt img-icon icon"></i>
                          }
                          @if (uploadingVishwaguru) {
                            <div class="img-icon-loader icon">
                              <img src="assets/images/loading.gif" width="40" alt="">
                            </div>
                          }
                        </div>
                        <input id="icon-vishwagurus" name="file-upload-field" type="file"
                          accept=".png, .jpg, .jpeg, .webp"
                          class="form-control d-none"
                          (change)="fileChangeEvent($event, imageCropperModal, 'VISHWAGURU')" required>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-3">
                      <button class="btn btn-primary btn-dashboard w-100" type="submit">Save</button>
                    </div>
                  </div>
                </form>
              </div>
            </form>
          </div>
        </div>
      </div>


      <ng-template #imageCropperModal>
        <div class="modal-header">
          <h5 class="modal-title">Add icon</h5>
          <button type="button" class="close " data-dismiss="modal" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true" class="">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <image-cropper
            (imageCropped)="imageCropped($event)"
            (loadImageFailed)="loadImageFailed()"
            [aspectRatio]=aspectRatio
            [imageChangedEvent]="imageChangedEvent"
            [maintainAspectRatio]="true"
            format="png">
          </image-cropper>
        </div>
        <div class="modal-footer justify-content-end">
          <button type="button" class="btn btn-default mr-2" data-dismiss="modal" (click)="modalRef.hide()">Close</button>
          <button (click)="uploadImage(this.croppedFile); modalRef.hide()" class="btn btn-primary btn-dashboard" type="button">Crop
          </button>
        </div>
      </ng-template>
